module.exports = __webpack_public_path__ + "static/img/COC2023-32.668a8d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-32.png
// module id = 3auf
// module chunks = 0